import { Chip, ListItemButton, ListItemText, Stack, Tooltip, Typography } from "@mui/material"
import Color from "color"
import { If } from "lib/@components/switch"
import { Repeat } from "lib/@components/repeat"
import { getContrastingColor } from "lib/get-contrasting-color"
import uniqolor from "uniqolor"

export function MacroListItem({ macro, selectedId, onSelect }) {
    if (!macro) return null
    const isSelected = macro.id === selectedId
    const categories = macro.categories ?? []

    return (
        <ListItemButton
            selected={isSelected}
            onClick={handleSelect}
            sx={{ py: 0.75 }}
            data-cy={`macro-list-item-${macro.id}`}
        >
            <ListItemText
                primary={
                    <Tooltip title={macro.name ?? "Macro"}>
                        <Typography
                            variant="subtitle2"
                            data-cy="macro-list-name"
                            sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "block",
                            }}
                        >
                            {macro.name ?? "Macro"}
                        </Typography>
                    </Tooltip>
                }
                secondary={
                    <If truthy={categories.length > 0}>
                        <Stack
                            component="span"
                            direction="row"
                            spacing={0.5}
                            useFlexGap
                            flexWrap="wrap"
                            sx={{ mt: 0.5 }}
                        >
                            <Repeat list={categories} item={<CategoryChip />} />
                        </Stack>
                    </If>
                }
            />
        </ListItemButton>
    )

    function handleSelect() {
        if (!onSelect) return
        onSelect(macro.id)
    }
}

function CategoryChip({ item: category }) {
    const { color } = uniqolor(category, { saturation: [65, 99], lightness: [65, 87] })
    const textColor = getContrastingColor(Color(color).mix(Color("white"), 0.5).hex())
    return <Chip label={category} size="small" sx={{ backgroundColor: `${color}80`, color: textColor }} />
}
